import { createReducer } from "@reduxjs/toolkit";
import { PAGES_ERROR, PAGES_LOADING, PAGES_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const pagesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(PAGES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(PAGES_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(PAGES_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default pagesReducer;
